import * as React from 'react';
import { Theme } from '..';

type SelectedType = Extract<'darkBlue' | 'white', keyof typeof Theme.colors>;

type LogoProps = {
  color: SelectedType;
};

const Logo = ({ color }: LogoProps) => {
  const hexColor = Theme.colors[color];
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={73} height={50} fill="none">
      <title>TalkTalk logo</title>
      <path
        fill={hexColor}
        d="M7.997 43.408a1.554 1.554 0 0 1-.156-.36 1.585 1.585 0 0 1-.072-.48c0-.312.068-.536.204-.672a.772.772 0 0 1 .552-.204h5.232c.056.088.108.208.156.36s.072.312.072.48c0 .312-.072.536-.216.672a.73.73 0 0 1-.54.204h-1.332v5.544a3.336 3.336 0 0 1-.42.072 4.264 4.264 0 0 1-.552.036 2.28 2.28 0 0 1-.492-.048.803.803 0 0 1-.348-.144.648.648 0 0 1-.216-.3 1.463 1.463 0 0 1-.072-.504v-4.656h-1.8Zm8.071-1.464c.136-.08.34-.156.612-.228.28-.072.56-.108.84-.108.4 0 .752.06 1.056.18.312.112.512.292.6.54.144.416.3.9.468 1.452a197.39 197.39 0 0 1 .996 3.456c.16.568.3 1.072.42 1.512a.95.95 0 0 1-.432.264c-.192.072-.42.108-.684.108-.192 0-.356-.016-.492-.048a.928.928 0 0 1-.324-.144.807.807 0 0 1-.204-.252 2.641 2.641 0 0 1-.132-.36l-.216-.828h-2.172c-.064.24-.128.488-.192.744s-.128.504-.192.744c-.112.04-.232.072-.36.096a1.75 1.75 0 0 1-.444.048c-.408 0-.712-.068-.912-.204a.696.696 0 0 1-.288-.588c0-.112.016-.224.048-.336a19.9 19.9 0 0 0 .108-.396c.056-.216.132-.484.228-.804l.336-1.032c.12-.376.248-.76.384-1.152l.384-1.104c.12-.352.228-.664.324-.936l.24-.624Zm1.44 1.548c-.112.336-.24.712-.384 1.128-.136.408-.26.824-.372 1.248h1.488a40.39 40.39 0 0 0-.348-1.26 53.85 53.85 0 0 0-.312-1.116h-.072Zm5.652 5.544c-.344 0-.616-.1-.816-.3-.2-.2-.3-.472-.3-.816v-6.204a8.54 8.54 0 0 1 .42-.06 3.36 3.36 0 0 1 .552-.048c.184 0 .344.016.48.048a.813.813 0 0 1 .36.144.648.648 0 0 1 .216.3c.048.128.072.296.072.504v4.74h2.748c.056.088.108.208.156.36.048.144.072.296.072.456 0 .32-.068.548-.204.684-.136.128-.316.192-.54.192H23.16Zm7.148-2.736v2.652a3.336 3.336 0 0 1-.42.072c-.192.024-.38.036-.564.036a2.28 2.28 0 0 1-.492-.048.803.803 0 0 1-.348-.144.648.648 0 0 1-.216-.3 1.463 1.463 0 0 1-.072-.504v-6.336a8.54 8.54 0 0 1 .42-.06 3.36 3.36 0 0 1 .552-.048c.184 0 .344.016.48.048a.813.813 0 0 1 .36.144.648.648 0 0 1 .216.3c.048.128.072.296.072.504v1.908l2.496-2.868c.544 0 .932.104 1.164.312.24.2.36.44.36.72 0 .208-.052.404-.156.588a3.065 3.065 0 0 1-.504.624l-1.5 1.5c.2.224.408.452.624.684.216.232.428.464.636.696l.6.648.54.564a1.03 1.03 0 0 1-.36.816 1.03 1.03 0 0 1-.36.216c-.136.048-.28.072-.432.072-.328 0-.596-.08-.804-.24a4.602 4.602 0 0 1-.6-.588L30.308 46.3Zm7.337-2.892a1.554 1.554 0 0 1-.156-.36 1.585 1.585 0 0 1-.072-.48c0-.312.068-.536.204-.672a.772.772 0 0 1 .552-.204h5.232c.056.088.108.208.156.36s.072.312.072.48c0 .312-.072.536-.216.672a.73.73 0 0 1-.54.204h-1.332v5.544a3.336 3.336 0 0 1-.42.072 4.264 4.264 0 0 1-.552.036 2.28 2.28 0 0 1-.492-.048.803.803 0 0 1-.348-.144.648.648 0 0 1-.216-.3 1.463 1.463 0 0 1-.072-.504v-4.656h-1.8Zm8.072-1.464c.136-.08.34-.156.612-.228.28-.072.56-.108.84-.108.4 0 .752.06 1.056.18.312.112.512.292.6.54.144.416.3.9.468 1.452a197.39 197.39 0 0 1 .996 3.456c.16.568.3 1.072.42 1.512a.95.95 0 0 1-.432.264c-.192.072-.42.108-.684.108-.192 0-.356-.016-.492-.048a.928.928 0 0 1-.324-.144.807.807 0 0 1-.204-.252 2.641 2.641 0 0 1-.132-.36l-.216-.828h-2.172c-.064.24-.128.488-.192.744s-.128.504-.192.744c-.112.04-.232.072-.36.096a1.75 1.75 0 0 1-.444.048c-.408 0-.712-.068-.912-.204a.696.696 0 0 1-.288-.588c0-.112.016-.224.048-.336a19.9 19.9 0 0 0 .108-.396c.056-.216.132-.484.228-.804l.336-1.032c.12-.376.248-.76.384-1.152l.384-1.104c.12-.352.228-.664.324-.936l.24-.624Zm1.44 1.548c-.112.336-.24.712-.384 1.128-.136.408-.26.824-.372 1.248h1.488a40.39 40.39 0 0 0-.348-1.26 53.85 53.85 0 0 0-.312-1.116h-.072Zm5.651 5.544c-.344 0-.616-.1-.816-.3-.2-.2-.3-.472-.3-.816v-6.204a8.54 8.54 0 0 1 .42-.06 3.36 3.36 0 0 1 .552-.048c.184 0 .344.016.48.048a.813.813 0 0 1 .36.144.648.648 0 0 1 .216.3c.048.128.072.296.072.504v4.74h2.748c.056.088.108.208.156.36.048.144.072.296.072.456 0 .32-.068.548-.204.684-.136.128-.316.192-.54.192h-3.216Zm7.148-2.736v2.652a3.336 3.336 0 0 1-.42.072c-.192.024-.38.036-.564.036a2.28 2.28 0 0 1-.492-.048.803.803 0 0 1-.347-.144.648.648 0 0 1-.217-.3 1.463 1.463 0 0 1-.072-.504v-6.336a8.54 8.54 0 0 1 .42-.06 3.36 3.36 0 0 1 .552-.048c.184 0 .344.016.48.048a.813.813 0 0 1 .36.144.648.648 0 0 1 .217.3c.047.128.072.296.072.504v1.908l2.495-2.868c.544 0 .933.104 1.165.312.24.2.36.44.36.72 0 .208-.053.404-.157.588a3.065 3.065 0 0 1-.504.624l-1.5 1.5c.2.224.408.452.624.684.217.232.428.464.637.696l.6.648.54.564a1.03 1.03 0 0 1-.36.816 1.03 1.03 0 0 1-.36.216c-.136.048-.28.072-.432.072-.328 0-.596-.08-.804-.24a4.602 4.602 0 0 1-.6-.588L59.956 46.3Z"
      />
      <g filter="url(#a)">
        <path
          stroke={hexColor}
          d="M6 .5h60A5.5 5.5 0 0 1 71.5 6v24a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 30V6A5.5 5.5 0 0 1 6 .5Z"
        />
        <path
          fill={hexColor}
          fillRule="evenodd"
          d="M36 0h30a6 6 0 0 1 6 6v24a6 6 0 0 1-6 6H36V0Zm9 7a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-5v17a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V12h-5a1 1 0 0 1-1-1V7Z"
          clipRule="evenodd"
        />
        <g fill={hexColor} filter="url(#b)">
          <path d="M9 7a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1V7ZM16 30a1 1 0 0 1-1-1V12h6v17a1 1 0 0 1-1 1h-4Z" />
        </g>
      </g>
      <defs>
        <filter
          id="a"
          width={73}
          height={37}
          x={0}
          y={0}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dx={1} dy={1} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.941176 0 0 0 0 0 0 0 0 0 0.392157 0 0 0 1 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1189_375"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_1189_375"
            result="shape"
          />
        </filter>
        <filter
          id="b"
          width={19}
          height={25}
          x={9}
          y={6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dx={1} dy={1} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.941176 0 0 0 0 0 0 0 0 0 0.392157 0 0 0 1 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1189_375"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_1189_375"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default Logo;
